import axios from 'axios'
import store from './../store'
const baseURL = '/'

// 请求拦截，在发送请求之前
axios.interceptors.request.use(function (config) {
  let condition = config.url.split('/')
  if (condition[condition.length - 1] === 'list') {
    store.commit('saveNormalListData', []);
  }
  store.commit('saveVisible', true)
  return config
}, function (error) {
  return Promise.reject(error)
})

// 请求回来时，修改返回的数据
axios.interceptors.response.use(function (res) {
  if (res.data.code === 200) {
    store.commit('saveVisible', false)
  }
  return res.data
}, function (error) {
  return Promise.reject(error)
})

function errorState (response) {
  return response
}

function successState (response) {
  if (response.code === 200) {
    // 提示请求成功
    return response
  } else {
    // 其他情况，将错误信息曝出
    errorState(response)
    return null
  }
}

// 封装axios
const httpServer = (opts, data) => {
  let httpDefaultOpts = {
    method: opts.method,
    baseURL: baseURL,
    url: opts.url,
    timeout: 1800000, // 前端30min延时控制
    params: data,
    data: data,
    headers: opts.type === 'formdata' ? {
      'Content-Type': 'multipart/form-data'
    } : {
    }
  }
  if (opts.method === 'get' || opts.method === 'GET') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }
  return new Promise(function (resolve, reject) {
    axios(httpDefaultOpts).then(
      (res) => {
        if (successState(res)) {
          resolve(res)
        } else {
          reject(res)
        }
      }
    ).catch(
      (err) => {
        errorState(err)
        reject(err)
      }
    )
  })
}

export default {
  install: function (Vue) {
    Vue.prototype.fetch = (url, params) => httpServer({method: 'GET', url: url}, params)
    Vue.prototype.post = (url, params) => httpServer({method: 'POST', url: url}, params)
    Vue.prototype.verify = (method, url, params, success, error) => {
      // if (localStorage.noValidation === 'yes') {
      vm[method](url, params).then(res => {
        if (success && typeof success === 'function') {
          success(res)
        }
      }).catch(error => {
        if (error && typeof error === 'function') {
          error(error);
        }
      })
      // } else {
      //   $('#verifyModal').modal('show');
      //   store.commit('setVerifyParam', {method, url, params, success, error});
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js